// extracted by mini-css-extract-plugin
module.exports =  {"collect-wrapper":"_4si2I5","collectWrapper":"_4si2I5","collect-btn":"Br2SdqC","collectBtn":"Br2SdqC","collected":"MLlkVl0"};